import RouteNames from '../RouteNames';

export default {
  [RouteNames.DIGITAL_SIGNALS]: {
    path: `/administration/:systemId(\\d+)/dataSource/${RouteNames.DIGITAL_SIGNALS}/:dataloggerId(\\d+)`,
    name: RouteNames.DIGITAL_SIGNALS,
  },
  [RouteNames.BATTERY_INVERTER_ASSIGNMENTS]: {
    path: `/administration/:systemId(\\d+)/dataSource/${RouteNames.BATTERY_INVERTER_ASSIGNMENTS}/:dataloggerId(\\d+)`,
    name: RouteNames.BATTERY_INVERTER_ASSIGNMENTS,
  },
  [RouteNames.DATASOURCE_DATALOGGER_OVERVIEW]: {
    path: '/administration/:systemId(\\d+)/dataSource/dataloggerOverview',
    name: RouteNames.DATASOURCE_DATALOGGER_OVERVIEW,
  },
};
